/* eslint-disable */
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import { useState } from 'react';
import helpImg1 from './imgs/help-1.png';
import helpImg2 from './imgs/help-2.png';
import helpImg3 from './imgs/help-3.png';

export default function HelpModal() {
    const [step, setStep] = useState(0);
    const helpStep = [
        {
            img: helpImg1,
            des: (
                <p className="text-black ">
                    <span className="font-bold">Bước 1: </span>Truy cập Youtube và chọn ra video của
                    bạn rồi click vào nút "Chia sẻ".
                </p>
            ),
        },
        {
            img: helpImg2,

            des: (
                <p className="text-black ">
                    {' '}
                    <span className="font-bold">Bước 2: </span>Sao chép video key của đường link có
                    dạng như sau.
                </p>
            ),
        },
        {
            img: helpImg3,

            des: (
                <p className="text-black ">
                    {' '}
                    <span className="font-bold">Bước 3: </span>Dán đoạn video key vừa sao chép lại
                    vào ô.
                </p>
            ),
        },
    ];

    return (
        <div
            className="fixed top-0 left-0 hidden w-full h-full overflow-x-hidden overflow-y-auto outline-none fade modal"
            id="helpModal"
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div className="relative w-auto pointer-events-none modal-dialog modal-dialog-centered modal-lg lg:max-w-[580px] 2xl:max-w-[800px]">
                <div className="relative flex flex-col w-full text-current bg-white border-none rounded-md shadow-lg outline-none pointer-events-auto modal-content bg-clip-padding">
                    <div className="flex items-center justify-between p-4 border-b border-gray-200 modal-header shrink-0 rounded-t-md">
                        <h5
                            className="text-[16px] font-bold leading-normal text-gray-800"
                            id="staticBackdropLabel"
                        >
                            Hướng dẫn lấy video key trên Youtube
                        </h5>
                        <button
                            type="button"
                            className="box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 btn-close hover:text-black hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                                setStep(0);
                            }}
                        ></button>
                    </div>
                    <div className="w-full flex justify-center items-center flex-col gap-4 p-4">
                        <img src={helpStep[step].img}></img>
                        {helpStep[step].des}
                    </div>
                    <div className="flex flex-wrap items-center justify-center p-4 border-t border-gray-200 modal-footer shrink-0 rounded-b-md">
                        {step !== 0 && (
                            <button
                                type="button"
                                onClick={() => {
                                    setStep(step - 1);
                                }}
                                className={`ml-1 inline-block rounded ${
                                    step === 0
                                        ? 'bg-gray-400'
                                        : 'bg-blue-600 hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg'
                                } px-6 py-2.5 text-[14px] font-medium leading-tight text-white shadow-md transition duration-150 ease-in-out flex items-center gap-2 `}
                            >
                                <FaArrowAltCircleLeft />
                                Trở lại
                            </button>
                        )}
                        {step !== helpStep.length - 1 && (
                            <button
                                onClick={() => {
                                    setStep(step + 1);
                                }}
                                className={`ml-1 inline-block rounded ${
                                    step === helpStep.length - 1
                                        ? 'bg-gray-400'
                                        : 'bg-blue-600 hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg'
                                } px-6 py-2.5 text-[14px] font-medium leading-tight text-white shadow-md transition duration-150 ease-in-out flex items-center gap-2 `}
                            >
                                Tiếp theo
                                <FaArrowAltCircleRight />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
